module.exports = __webpack_public_path__ + "img/box9-13.070e6b04.png";